import React, { FC, useMemo, useRef } from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";
import ChevronDown from "../../../../assets/ChevronDownNew.svg";
import Close from "../../../../assets/Close.svg";
import CheckMark from "../../../../assets/CurrencyCheckMark.svg";
import { CURRENCY_FLAGS } from "static/currencies";
import { timer } from "helpers/functions";

export interface CurrencyCardProps {
  code: string;
  symbol: string;
  name: string;
  amount: number;
}

type PropsType = {
  data: CurrencyCardProps[];
  selectedCode: string;
  onSelect: (code: string) => void;
  onSheetToggle: (isOpen: boolean) => void;
  isSheetOpen: boolean;
  amount: number | "";
  setAmount: (val: number | "") => void;
  hide?: boolean;
  sign: "-" | "+";
  placeholder?: string;
  validation?: boolean;
};

const CurrencyCard: FC<PropsType> = ({
  data,
  selectedCode,
  onSelect,
  onSheetToggle,
  isSheetOpen,
  amount,
  setAmount,
  hide = false,
  sign,
  placeholder,
  validation,
}) => {
  const { t } = useTranslation("app");
  const inputRef = useRef<HTMLInputElement>(null);

  const handleOpen = () => onSheetToggle(true);
  const handleClose = () => onSheetToggle(false);

  const selectedCurrency = data.find((item) => item.code === selectedCode);

  const placeholderActive = placeholder && amount === "";

  // const inputColor = useMemo(() => {
  //   // if (validation) {
  //   //   return "#E82127";
  //   // } else {
  //   return isNaN(+amount) || amount === "" ? "#c1c5cf" : "#00123a";
  //   // }
  // }, [amount]);

  return (
    <div className="currency-card">
      <div
        className="currency-card__left"
        onClick={handleOpen}
        style={{
          height: sign === "-" ? "100%" : "auto",
        }}
      >
        <div className="currency-card__left__top">
          <img
            className="currency-card__left__top__flag"
            src={CURRENCY_FLAGS[selectedCode]}
            alt={`${selectedCode} flag`}
          />
          <p>
            {selectedCode}
            <img src={ChevronDown} alt="Open dropdown" />
          </p>
        </div>

        {sign === "-" && (
          <p
            className="currency-card__left__balance"
            style={{
              color:
                sign === "-" &&
                selectedCurrency &&
                selectedCurrency.amount + 0.0001 < +amount
                  ? "#f95260a6"
                  : "#c1c5cf",
            }}
          >
            {t("available")}:{" "}
            {hide
              ? "•••••"
              : selectedCurrency
              ? +selectedCurrency.amount.toFixed(4)
              : "0"}
            {selectedCurrency?.symbol}
          </p>
        )}
      </div>

      <div
        className="currency-card__amount"
        onClick={(e) => {
          inputRef.current?.focus();
        }}
      >
        {sign && !placeholderActive && (
          <div
            className="currency-card__amount-sign"
            style={{
              color: isNaN(+amount) || amount === "" ? "#c1c5cf" : "#00123a",
            }}
          >
            {sign}
          </div>
        )}

        <input
          ref={inputRef}
          type="number"
          value={amount === "" ? "" : amount}
          placeholder={placeholder ? placeholder : "0"}
          min={0}
          onChange={(e) => {
            const val = e.target.value;

            if (val === "") {
              setAmount("");
            } else {
              setAmount(Number(val));
            }
          }}
          aria-label={`${selectedCode} amount input`}
          className="currency-card__amount-input"
          style={{
            width: placeholderActive
              ? placeholder.length * 1 + "ch"
              : String(isNaN(+amount) ? "" : amount).length > 1
              ? `${String(isNaN(+amount) ? "" : amount).length}ch`
              : "1.4ch",
            color: isNaN(+amount) || amount === "" ? "#c1c5cf" : "#00123a",
          }}
        />

        <p
          style={{
            color: isNaN(+amount) || amount === "" ? "#c1c5cf" : "#00123a",
          }}
        >
          {selectedCurrency?.symbol}
        </p>
      </div>

      {isSheetOpen && (
        <div
          className="currency-card-bottomsheet-overlay"
          onClick={(e) => {
            e.stopPropagation();
            handleClose();
          }}
        >
          <div
            className="currency-card-bottomsheet"
            onClick={(e) => {
              e.stopPropagation();
              timer(0.1).then(() => {
                handleClose();
              });
            }}
          >
            <div className="currency-card-bottomsheet__header">
              <p>{t("chooseCurrency")}</p>
              <button onClick={handleClose} aria-label={t("close")}>
                <img src={Close} alt={t("close")} />
              </button>
            </div>

            <div className="currency-card-bottomsheet__rows">
              {data.map((item) => (
                <div
                  key={item.code}
                  className={`currency-card-bottomsheet__rows__row ${
                    item.code === selectedCode ? "selected" : ""
                  }`}
                  onClick={() => onSelect(item.code)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      onSelect(item.code);
                    }
                  }}
                >
                  <div className="currency-card-bottomsheet__rows__row__left">
                    <div className="cur-flag-wrapper">
                      <img
                        className="checked"
                        src={CURRENCY_FLAGS[item.code]}
                        alt={`${item.code} flag`}
                      />
                      {item.code === selectedCode && (
                        <img
                          className="cur-flag-checkmark"
                          src={CheckMark}
                          alt={t("selected")}
                        />
                      )}
                    </div>
                    <div>
                      <p>{item.code}</p>
                      <span>{item.name}</span>
                    </div>
                  </div>
                  {/* !== 0: минусовой остаток тоже печатаем, см. home/index.tsx */}
                  {item.amount !== 0 && (
                    <p>
                      {+item.amount.toFixed(4)}
                      {item.symbol}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CurrencyCard;
